module.exports = __webpack_public_path__ + "img/nutrisense.b825dc01.png";